import { NgZone } from '@angular/core';
import { MonoTypeOperatorFunction, Observable } from 'rxjs';

/**
 * Re-delivers a stream's notifications inside the Angular zone.
 *
 * The vendored fire-compat emits OUTSIDE the zone (CLAUDE.md). When such a stream decides a route
 * guard, the router finishes the navigation outside the zone too, so the page it builds registers
 * its DOM listeners in the root zone and typing or clicking on it never triggers change detection
 * (a cold load of /app/issues/list: the search filtered nothing on screen, ISS-033).
 */
export function enterZone<T>(zone: NgZone): MonoTypeOperatorFunction<T> {
    return (source) =>
        new Observable<T>((subscriber) =>
            source.subscribe({
                next: (value) => zone.run(() => subscriber.next(value)),
                error: (err: unknown) => zone.run(() => subscriber.error(err)),
                complete: () => zone.run(() => subscriber.complete()),
            })
        );
}
